import { render, staticRenderFns } from "./TutorAvatar.vue?vue&type=template&id=b1e3b5ba&"
import script from "./TutorAvatar.vue?vue&type=script&lang=js&"
export * from "./TutorAvatar.vue?vue&type=script&lang=js&"
import style0 from "./TutorAvatar.vue?vue&type=style&index=0&id=b1e3b5ba&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports